<template>
  <div class="integrations-view">
    <section class="p-3">
      <eg-b-row>
        <eg-b-col cols="12">
          <div>
            <account-header :title="$t('account.integrations')" />
            <div>
              {{ $t("account.connectLms") }}
            </div>
          </div>
        </eg-b-col>
      </eg-b-row>
      <eg-b-row v-if="!loading" class="mb-3 mt-2">
        <div
          v-if="oauthProfiles.length"
          class="d-flex flex-wrap align-items-stretch integration-cards-row"
        >
          <eg-b-card
            v-for="profile in oauthProfiles"
            :key="profile.id"
            class="m-2 integration-card h-100 d-flex flex-column"
          >
            <div class="card-title d-flex flex-shrink-0 align-items-center">
              <div class="d-flex flex-column align-items-center w-100">
                <img
                  class="option-icon mb-3"
                  :src="providers[profile.provider]?.icon"
                  alt=""
                />
                <span class="title text-center">
                  {{ providers[profile.provider]?.label }}
                </span>
              </div>
            </div>
            <div class="card-content flex-grow-1">
              <div class="text-center">
                <div class="d-flex align-items-center">
                  <!-- <b class="field-col">Email</b> -->
                  <div class="w-100">{{ profile.userPublicIdentifier }}</div>
                </div>
                <div v-if="profile.url" class="d-flex align-items-center">
                  <!-- <b class="field-col">URL</b> -->
                  <div class="w-100">{{ profile.url }}</div>
                </div>
              </div>
            </div>
            <eg-b-button
              v-if="!profile.isSignIn"
              variant="outline-info"
              size="sm"
              class="integration-card__remove w-100 flex-shrink-0"
              @click="unlink(profile.id)"
            >
              {{ $t("account.unlink") }}
            </eg-b-button>
            <!--            <template-->
            <!--              v-if="-->
            <!--                profile.provider === 'canvasPersonal' && features?.bulkImports-->
            <!--              "-->
            <!--            >-->
            <!--              <div class="divider"></div>-->
            <!--              <div class="card-content">-->
            <!--                <eg-b-button-->
            <!--                  variant="outline-info"-->
            <!--                  size="sm"-->
            <!--                  class="ml-auto"-->
            <!--                  to="/imports/canvas"-->
            <!--                >-->
            <!--                  Import new Assignments-->
            <!--                </eg-b-button>-->
            <!--                <div class="mt-2">-->
            <!--                  <b class="d-flex">Import/Export settings for this account</b>-->
            <!--                  <div class="mt-2">-->
            <!--                    <eg-b-form-checkbox-->
            <!--                      :value="autoGradeSubmission"-->
            <!--                      name="auto-grade-submission"-->
            <!--                      switch-->
            <!--                      @input="-->
            <!--                        updateSettings({-->
            <!--                          type: 'autoGradeSubmission',-->
            <!--                          value: $event,-->
            <!--                        })-->
            <!--                      "-->
            <!--                    >-->
            <!--                      Automatically grade new submissions-->
            <!--                    </eg-b-form-checkbox>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </template>-->
          </eg-b-card>
        </div>
        <eg-b-col v-else>
          <empty-state
            :title="$t('account.noActiveIntegrations')"
            :link="{ to: '/', text: $t('account.connectLms') }"
          ></empty-state>
        </eg-b-col>
      </eg-b-row>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { LMS_PROVIDERS } from "@/constants";
import { getUserOauthProfiles, deleteUserOauthProfile, getUser } from "@/api";
import EmptyState from "@/components/global/empty_state.vue";
import { mergeUserData } from "@/utils/userUtils";
import AccountHeader from "@/views/account/account_header.vue";

export default {
  components: {
    AccountHeader,
    EmptyState,
  },

  data() {
    return {
      providers: LMS_PROVIDERS,
      loading: true,
      oauthProfiles: [],
      autoGradeSubmission: false,
    };
  },

  computed: {
    ...mapGetters("config", ["features"]),
    user() {
      return this.$store.state.user;
    },
  },

  created() {
    this.init();
  },

  methods: {
    updateSettings({ type, value }) {
      console.log(type, value);
    },

    async updateUserData() {
      const { data } = await getUser("me");
      const userData = mergeUserData(this, data);
      await this.$store.dispatch("setUser", userData);
    },

    async unlink(profileId) {
      await deleteUserOauthProfile(this.user.id, profileId);
      this.oauthProfiles = this.oauthProfiles.filter(
        (profile) => profile.id !== profileId
      );
      await this.updateUserData();
    },

    async init() {
      this.loading = true;
      try {
        const {
          data: { oauthProfiles },
        } = await getUserOauthProfiles(this.user.id);
        this.oauthProfiles = oauthProfiles;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.divider {
  width: 100%;
  height: 1px;
  background-color: var(--color-stroke-neutral-default);
}

.field-col {
  width: 50px;
}

.integration-cards-row {
  min-height: 0;
}

.integration-card {
  width: 300px;
  min-height: 0;

  /* BCard default slot: flex column (card root also uses d-flex flex-column h-100) */
  &::v-deep .card-body {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
  }
}

.integration-card__remove {
  margin-top: auto;
}

.option-icon {
  height: 70px;
  width: auto;
}

.title {
  font-family: Inter;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: bottom;
}
</style>
